import React from 'react';
import { GAN_WX, ZHI_WX } from './tables.js';
import { SHI_SHEN_MEANING, PLAIN_SHI_SHEN, PILLAR_GOD_MEANING, CHANGSHENG_MEANING, NAYIN_NOTE } from './meanings.js';

const WX_COLOR = { 木: '#2e7d32', 火: '#c62828', 土: '#9c6b3f', 金: '#607d8b', 水: '#1565c0' };
const ROLE = { 年柱: '祖上根基 · 早年（约1-16岁）', 月柱: '父母兄弟 · 青年（提纲）', 日柱: '自身与配偶 · 中年', 时柱: '子女晚景 · 归宿' };

function GodBlock({ god, ch, wx, pillarLabel }) {
  return (
    <div className="pd-block">
      <div className="pd-block-head">
        <b style={{ color: WX_COLOR[wx] }}>{ch}</b>
        <i>{wx}</i>
        <em className="pd-god">{god}</em>
      </div>
      {PLAIN_SHI_SHEN[god] && <p className="pd-plain">💬 {PLAIN_SHI_SHEN[god]}</p>}
      <p className="pd-line"><b>落在此柱</b>：{PILLAR_GOD_MEANING[god]?.[pillarLabel] || '—'}</p>
      {SHI_SHEN_MEANING[god] && <p className="pd-classic">古义：{SHI_SHEN_MEANING[god]}</p>}
    </div>
  );
}

export default function PillarDetail({ p }) {
  if (!p) return null;
  const nayinWx = p.naYin.slice(-1); // 纳音名末字即五行（X金/X木…）
  return (
    <div className="pillar-detail">
      <h5>
        {p.label} · {p.gan}{p.zhi}
        <small>　{ROLE[p.label]}{p.key === 'day' ? ' · 日主所在' : ''}</small>
      </h5>

      {/* 天干 */}
      <GodBlock god={p.ssGan} ch={p.gan} wx={GAN_WX[p.gan]} pillarLabel={p.label} />

      {/* 地支 + 藏干 */}
      <div className="pd-block">
        <div className="pd-block-head">
          <b style={{ color: WX_COLOR[ZHI_WX[p.zhi]] }}>{p.zhi}</b>
          <i>{ZHI_WX[p.zhi]}</i>
          <em className="pd-god">{p.zhi}支 · 藏{p.hide.join('、')}</em>
        </div>
        <p className="pd-line">
          <b>十二长生</b>：行「{p.csZhi}」—— {CHANGSHENG_MEANING[p.csZhi]}
        </p>
        {p.hide.map((h, i) => (
          <p key={i} className="pd-line pd-hide-line">
            藏干 <b style={{ color: WX_COLOR[GAN_WX[h]] }}>{h}</b>（{GAN_WX[h]}·{p.ssZhi[i]}）
            —— {PLAIN_SHI_SHEN[p.ssZhi[i]] || ''} {PILLAR_GOD_MEANING[p.ssZhi[i]]?.[p.label] ? `｜${PILLAR_GOD_MEANING[p.ssZhi[i]][p.label]}` : ''}
          </p>
        ))}
      </div>

      {/* 纳音 */}
      <div className="pd-block">
        <div className="pd-block-head">
          <b style={{ color: WX_COLOR[nayinWx] }}>{p.naYin}</b>
          <i>纳音{nayinWx}</i>
        </div>
        <p className="pd-plain">💬 这柱的「属性标签」是<b>{p.naYin}</b>（属{nayinWx}）。名字即意象——描述这柱五行之气所处的状态。</p>
        <p className="pd-classic">{NAYIN_NOTE}</p>
      </div>
    </div>
  );
}
